/** The display modes a location collection can be shown in. */
export type LocationViewMode = 'cards' | 'table' | 'map'

/**
 * The mode to actually render, given the user's stored preference and viewport.
 *
 * Two rules, and the second is the one that is easy to get wrong:
 *
 *  1. Cards needs room. It is the least dense layout there is, which makes it
 *     the worst choice on a narrow screen. The CALLER says what counts as too
 *     narrow: the Locations index passes the phone cut-off (below 768px, so
 *     tablets keep Cards, MYD-560); PortfolioLocationsList still passes
 *     `useIsMobile` (below 1024px).
 *  2. Whether Map passes through on mobile is the CALLER'S choice, because the
 *     two callers genuinely differ. PortfolioLocationsList keeps its mobile
 *     List/Map toggle, so coercing Map away there would make half that toggle
 *     inert. The Locations index no longer offers Map on a phone at all, so
 *     letting a stored 'map' through would strand the user on a view they
 *     cannot leave. Hence an explicit flag rather than one rule pretending to
 *     suit both.
 *
 * This COERCES for rendering and never writes back. The caller keeps persisting
 * the raw preference, so a phone visit cannot overwrite a desktop Cards choice
 * and resizing across the breakpoint restores it with no reload.
 */
export const resolveViewMode = (
	stored: LocationViewMode,
	tooNarrow: boolean,
	{ mapOnMobile = true }: { mapOnMobile?: boolean } = {},
): LocationViewMode => {
	if (!tooNarrow) return stored
	if (stored === 'map' && mapOnMobile) return 'map'
	return 'table'
}

export default resolveViewMode
